/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderStepProvideAPI
 * Use by feature to register their own rendering step into the {@link RenderSequenceAPI}
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class RenderStepProvideAPI {

		/**
		 * Render step definition
		 * @typedef {Object} RenderStepProvideAPI.RenderStepDefinition
		 * @property {String} id  Render step id
		 * @property {String[]} dependencies Array of steps ids that this step depends on
		 * @property {String} modulePath module path to be used for the rendering step
		 * @property {Class} module module class to be used for the rendering step
		 * @property {Object} moduleOptions options to be passed in the constructor to the step when the instance is created
		 * 
		 */

		/**
		 * @public
		 * @function RenderStepProvideAPI#getRenderStepList
		 * @description Return a list of additional render steps that will be part of the visualization rendering sequence
		 * @return {RenderStepProvideAPI.RenderStepDefinition[]} steps - steps to register
		 * 
		 */
		getRenderStepList() {}

	}

	return RenderStepProvideAPI;
});